module.exports = __webpack_public_path__ + "static/media/streaming.6aab118d.svg";